import { ContainerBlot as ContainerBlot$1 } from '../../../../node_modules/parchment/dist/parchment.js';

class Container extends ContainerBlot$1 {}

export { Container as default };
